import React from 'react';
import { CalendarCheck, Lock, ReceiptText, Settings2 } from 'lucide-react';

const ITEMS = [
  [Lock, 'Secure online payments'],
  [CalendarCheck, 'No minimum commitment on monthly Pro'],
  [Settings2, 'Manage subscriptions from your account'],
  [ReceiptText, 'Transparent renewal pricing'],
];

export const PricingReassurance = () => (
  <ul className="mt-12 max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-5 pt-8 border-t border-slate-200" data-testid="pricing-reassurance-row">
    {ITEMS.map(([Icon, label]) => (
      <li key={label} className="flex flex-col sm:flex-row items-center justify-center gap-2 text-center sm:text-left text-xs sm:text-sm font-medium text-slate-600">
        <span className="p-2 rounded-full bg-white border border-slate-200 shrink-0"><Icon className="w-4 h-4 text-[#00247D]" /></span>{label}
      </li>
    ))}
  </ul>
);
